import { DocumentTabType } from '@heidi/schema/ml-scribe';

/**
 * Single source of truth for "is this document tab a markdown-native editor
 * surface": the flag is on and the tab is a text-editor surface — everything
 * except PDF (own viewer) and prechart (stays in the HTML block editor, which
 * round-trips HTML that markdown would collapse). Denylist by design, so
 * DOCUMENT / DICTATION / CARE_PATH / PATIENT_SUMMARY and any future text type
 * route here without enumeration. A null/undefined tab type (document not yet
 * loaded) resolves to the flag value, matching the prior `flag && !isPrechart`.
 *
 * Layer editability gates (reviewing-other-user, generating) on top separately
 * via `resolveMarkdownNativeDocumentEditable` — this is the surface predicate,
 * not the editability one.
 */
export const isMarkdownNativeDocumentSurface = (
  flagEnabled: boolean,
  documentTabType: DocumentTabType | null | undefined
): boolean =>
  flagEnabled &&
  documentTabType !== DocumentTabType.PDF &&
  documentTabType !== DocumentTabType.PRECHART;
